import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as feedDuck from '../Dashboard/feedDuck'
import AuthenticatedSearchEducationIndex from './routes/Education/AuthenticatedSearchEducationIndex'
import PageTitle from '../../../components/ui/typography/PageTitle'
import AuthenticatedSearchCareerIndex from './routes/Career/AuthenticatedSearchCareerIndex'
import selectors from '../../../store/shared/selectors'
import intercom from '../../../utils/intercom/intercomUtils'
import PlayButton from '../../../components/ui/playButton/PlayButton'
import constants from '../../../utils/constants/application'
import FeedItemModalDisplay from '../Dashboard/components/FeedItemModalDisplay'
import sendFullStoryEvent from '../../../utils/analyticsHelpers/sendFullStoryEvent'
import fullstory from '../../../utils/constants/fullstory'

class AuthenticatedResumeSearchIndex extends Component {
  static propTypes = {
    queryParams: PropTypes.any,
    userId: PropTypes.string,
  }

  constructor() {
    super()

    this.state = {
      activeIndex: 1,
      tourName: null,
    }

    this.onChangeActiveIndex = nextIndex =>
      this.setState({ activeIndex: nextIndex, tourName: null })

    this.onChangeResultsPage = nextTourName => {
      if (this.state.tourName !== nextTourName) {
        this.setState({ tourName: nextTourName })

        if (nextTourName === 'careerPage1' || nextTourName === 'educationPage1') {
          sendFullStoryEvent(fullstory.eventNames.filterResultsByEducation)
        }
        if (nextTourName === 'educationPage2') {
          sendFullStoryEvent(fullstory.eventNames.filterResultsByEmployment)
        }
        if (nextTourName === 'educationPage3') {
          sendFullStoryEvent(fullstory.eventNames.filterResultsByCareerPath)
        }
      }
    }
  }

  componentDidMount() {
    setTimeout(() => {
      const { searchType } = this.props.queryParams
      if (searchType === 'education') {
        this.setState({ activeIndex: 0 })
      } else if (searchType === 'career') {
        this.setState({ activeIndex: 1 })
      }
    })

    intercom.intercomUpdate({
      user_id: this.props.userId,
    })
  }

  render() {
    const { openModal } = this.props
    const { activeIndex, tourName } = this.state
    const resultTabs = [
      {
        title: 'Education Background',
        mobileLabel: 'Education',
        icon: 'fa-graduation-cap',
        tutorial: constants.tutorialsFeedItems.educationBackground,
      },
      {
        title: 'Salary & Career',
        mobileLabel: 'Employment',
        icon: 'fa-dollar-sign',
        tutorial: constants.tutorialsFeedItems.salaryAndCareer,
      },
      {
        title: 'Real Career Paths',
        mobileLabel: 'Career Paths',
        icon: 'fa-user',
        tutorial: constants.tutorialsFeedItems.careerPaths,
      },
      {
        title: 'Common Job Skills',
        mobileLabel: 'Skills',
        icon: 'fa-wrench',
        tutorial: constants.tutorialsFeedItems.skills,
      },
    ]

    return (
      <div className="main-page" style={{ marginBottom: 250 }}>
        <PageTitle content="Search Millions of Career Paths" showHistoryBtn tourName={tourName}>
          <PlayButton
            additionalStyles={{ paddingBottom: '15px', marginLeft: '-5px' }}
            handleClick={() => openModal(constants.tutorialsFeedItems.search360)}
          />
        </PageTitle>
        <div style={{ marginTop: 20, marginBottom: 10 }}>
          <div className="btn-group">
            <button
              className={`btn ${activeIndex === 1 ? 'btn-primary' : 'btn-outline-secondary'}`}
              onClick={() => {
                this.setState({ activeIndex: 1 })

                sendFullStoryEvent(fullstory.eventNames.searchByCareer)
              }}
            >
              Search by Career
            </button>
            <button
              className={`btn ${activeIndex === 0 ? 'btn-primary' : 'btn-outline-secondary'}`}
              onClick={() => {
                this.setState({ activeIndex: 0 })
                sendFullStoryEvent(fullstory.eventNames.searchByMajor)
              }}
            >
              Search by Major
            </button>
          </div>
        </div>
        <div>
          {activeIndex === 0 ? (
            <AuthenticatedSearchEducationIndex
              titles={resultTabs}
              onChangeResultsPage={this.onChangeResultsPage}
              openModal={openModal}
            />
          ) : (
            <AuthenticatedSearchCareerIndex
              titles={resultTabs}
              onChangeResultsPage={this.onChangeResultsPage}
              openModal={openModal}
            />
          )}
        </div>
        <FeedItemModalDisplay />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  queryParams: selectors.getQueryStringSimply(state),
  userId: selectors.getUserId(state),
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      openModal: feedDuck.openModal,
    },
    dispatch,
  )

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticatedResumeSearchIndex)



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/AuthenticatedResumeSearchIndex.js